import keys from '@debbie/common/dist/cache/keys.js';
import { getCollectorOnCase } from '@debbie/common/dist/cases/index.js';
import { isDebtorPMV } from '@debbie/common/dist/cosmo/synapses/experian/rki.js';
import { FoundationCode, getDebtorsOnCustomer, } from '@debbie/common/dist/customers/index.js';
import { canRegisterInRegistry, getDateOfLatestWarning, } from '@debbie/common/dist/debt-register/denmark.js';
import { Registry } from '@debbie/common/dist/debt-register/index.js';
import { getFoundations, isDocumentFoundation, } from '@debbie/common/dist/documents/index.js';
import helpers from '@debbie/common/dist/economy/helpers/index.js';
import { Entity, formatNumber } from '@debbie/common/dist/index.js';
import { casesEntity, ensureCaseLoaded, } from '@debbie/cortex/dist/cases/index.js';
import { useCollector } from '@debbie/cortex/dist/collectors/index.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { customersEntity, ensureCustomerLoaded, useCustomer, } from '@debbie/cortex/dist/customers/index.js';
import { ensureRegistriesByCaseIdLoaded, registriesEntity, useRegistriesByCaseId, } from '@debbie/cortex/dist/debt-registries/index.js';
import { useDocumentsByReference } from '@debbie/cortex/dist/documents/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { interactionsByReferenceKey, useInteractionsByReference, } from '@debbie/cortex/dist/interactions/index.js';
import { useMe } from '@debbie/cortex/dist/me/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useTemplates } from '@debbie/cortex/dist/templates/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import { useUpdatesByRefId } from '@debbie/cortex/dist/updates/index.js';
import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import Alert from '../Alert.js';
import { Col, Row } from '../Grid/index.js';
import { CheckCircle, Shield } from '../Icons/index.js';
import { Badge, Button, Checkbox, DateInput, File as FileComponent, Input, Modal, SearchInput, Select, Table, Well, } from '../index.js';
import { getAvailableRegistries, getDescriptor } from './registries.js';
const NewRegistrationModal = (props) => {
    const { debtorUser, setUserId, case: singleCase, caseVouchers: kaseVouchers, } = props;
    const lang = useSelector((s) => s.lang);
    const [amount, setAmount] = useState(null);
    const [withFoundation, setWithFoundation] = useState(false);
    const [foundationCode, setFoundationCode] = useState(null);
    const [foundationDate, setFoundationDate] = useState(null);
    const [dateOfLatestWarning, setDateOfLatestWarning] = useState(null);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [reporting, setReporting] = useState(false);
    const [personName, setPersonName] = useState(null);
    const [errorDescription, setErrorDescription] = useState(null);
    const [errorRequest, setErrorRequest] = useState(null);
    const [selectedRegistries, setSelectedRegistries] = useState(new Set());
    const [registrationResults, setRegistrationResults] = useState(null);
    const meLoadable = useMe();
    const me = h.hasData(meLoadable) ? meLoadable.data : null;
    const tenant = useTenant();
    const interactionsLoadable = useInteractionsByReference(Entity.Case, singleCase?.caseId);
    const interactions = h.hasData(interactionsLoadable)
        ? interactionsLoadable.data
        : null;
    const updatesLoadable = useUpdatesByRefId(singleCase?.caseId);
    const updates = h.hasData(updatesLoadable) ? updatesLoadable.data : null;
    const templatesLoadable = useTemplates();
    const templates = h.hasData(templatesLoadable) ? templatesLoadable.data : null;
    const documentsLoadable = useDocumentsByReference(singleCase.caseId);
    const documents = h.hasData(documentsLoadable) ? documentsLoadable.data : null;
    const debtRegistriesLoadable = useRegistriesByCaseId(singleCase?.caseId);
    const debtRegistries = h.hasData(debtRegistriesLoadable)
        ? debtRegistriesLoadable.data
        : [];
    const creditorLoadable = useCreditor(singleCase?.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const customerLoader = useCustomer(singleCase?.customerId);
    const customer = h.hasData(customerLoader) ? customerLoader.data : null;
    const collectorLoadable = useCollector((props.case &&
        creditor &&
        getCollectorOnCase(props.case.type, props.case.collectorId, creditor.identityCollectorId, creditor.defaultCollectorId)) ||
        undefined);
    const collector = h.hasData(collectorLoadable) ? collectorLoadable.data : null;
    const manglerAdvokatindestaaelse = tenant?.settings?.manglerAdvokatindestaaelse === true;
    // The one availability computation every consumer below shares, so the rule
    // can never drift between call sites.
    const availableDescriptors = useMemo(() => creditor
        ? getAvailableRegistries(creditor, {
            withFoundation,
            manglerAdvokatindestaaelse,
        })
        : [], [creditor, withFoundation, manglerAdvokatindestaaelse]);
    const foundationCapableDescriptors = useMemo(() => creditor
        ? getAvailableRegistries(creditor, {
            withFoundation: true,
            manglerAdvokatindestaaelse,
        })
        : [], [creditor, manglerAdvokatindestaaelse]);
    useEffect(() => {
        if (amount) {
            return;
        }
        if (!kaseVouchers) {
            setAmount(0);
            return;
        }
        const balance = -helpers.overview.balance(kaseVouchers);
        setAmount(balance / 100);
    }, [kaseVouchers]);
    useEffect(() => {
        if (!interactions) {
            q.invalidate([interactionsByReferenceKey(Entity.Case, singleCase.caseId)]);
        }
    }, [interactions]);
    useEffect(() => {
        if (documents) {
            const foundations = getFoundations(documents);
            if (foundations.length > 0) {
                setWithFoundation(true);
                setFoundationDate(moment(foundations[0].signedAt || foundations[0].date));
            }
        }
    }, [documents]);
    useEffect(() => {
        setErrorRequest(null);
    }, []);
    useEffect(() => {
        if (!creditor) {
            return;
        }
        setSelectedRegistries(new Set(availableDescriptors.map((d) => d.registry)));
    }, [creditor?.creditorId]);
    useEffect(() => {
        if (!creditor) {
            return;
        }
        const available = new Set(availableDescriptors.map((d) => d.registry));
        setSelectedRegistries((prev) => {
            const next = new Set(prev);
            // Registries that require a foundation can only be selected while
            // withFoundation is on; toggle them in/out as it changes.
            Object.values(Registry).forEach((registry) => {
                const descriptor = getDescriptor(registry);
                if (!descriptor.requiresFoundation) {
                    return;
                }
                if (available.has(registry)) {
                    next.add(registry);
                }
                else {
                    next.delete(registry);
                }
            });
            return next;
        });
    }, [withFoundation]);
    useEffect(() => {
        if (interactions && updates && templates) {
            const date = getDateOfLatestWarning(interactions, updates, templates);
            if (date) {
                setDateOfLatestWarning(moment(date));
            }
        }
    }, [interactions, updates, templates]);
    const getPersonName = (debtorUser) => {
        if (!personName &&
            debtorUser &&
            debtorUser.details.companyRelations &&
            debtorUser.details.companyRelations[0] &&
            debtorUser.details.companyRelations[0].name) {
            return debtorUser.details.companyRelations[0].name;
        }
        return personName;
    };
    const registerReport = async () => {
        if (!debtorUser) {
            alert('Ingen debitor valgt.');
            return;
        }
        if (!foundationDate && !dateOfLatestWarning) {
            alert('No foundation date');
            return;
        }
        if (!amount || amount <= 0) {
            alert('No amount specified');
            return;
        }
        setReporting(true);
        const claim = {
            amount: Math.round(amount * 100),
            foundationCode: withFoundation ? foundationCode || undefined : undefined,
            foundationDate: withFoundation
                ? foundationDate?.format()
                : dateOfLatestWarning?.format(),
        };
        const tasks = availableDescriptors
            .filter((d) => selectedRegistries.has(d.registry))
            .map((d) => ({
            registry: d.registry,
            fn: () => d.api.report({
                userId: debtorUser.userId,
                caseId: singleCase.caseId,
                claim,
                personName: getPersonName(debtorUser) || undefined,
                files: manglerAdvokatindestaaelse
                    ? selectedFiles.map((f) => f.fileId)
                    : undefined,
            }),
        }));
        const outcomes = await Promise.allSettled(tasks.map((t) => t.fn()));
        const results = {};
        tasks.forEach((task, i) => {
            const outcome = outcomes[i];
            results[task.registry] = {
                status: outcome.status === 'fulfilled' ? 'success' : 'error',
                error: outcome.status === 'rejected'
                    ? String(outcome.reason?.message ?? outcome.reason)
                    : undefined,
            };
        });
        setRegistrationResults(results);
        q.invalidate(keys.write.modify(casesEntity, singleCase.caseId));
        q.invalidate(keys.write.modify(customersEntity, props.customer.customerId));
        q.invalidate(keys.write.create(registriesEntity));
        await ensureCaseLoaded(singleCase.caseId);
        await ensureRegistriesByCaseIdLoaded(singleCase.caseId);
        await ensureCustomerLoaded(props.customer.customerId);
        const hasErrors = Object.values(results).some((r) => r?.status === 'error');
        if (!hasErrors) {
            props.toggleModal();
        }
        else {
            // Each registry declares how its own report failures are presented, so
            // no registry needs a hand-rolled branch here.
            for (const task of tasks) {
                const result = results[task.registry];
                if (result?.status !== 'error' || result.error == null) {
                    continue;
                }
                const detail = getDescriptor(task.registry).parseReportError?.(result.error);
                if (detail) {
                    setErrorRequest(detail.request ?? null);
                    setErrorDescription(detail.description ?? null);
                    break;
                }
            }
        }
        setReporting(false);
    };
    const debtors = customer && getDebtorsOnCustomer(customer);
    const searchDebtors = (q) => debtors
        ? debtors
            .filter((d) => d.details.name?.toLowerCase().indexOf(q.toLowerCase()) !== -1)
            .map((d) => ({
            heading: d.details.name || '-',
            returnData: d.userId,
            key: d.userId,
        }))
        : [];
    const isPMV = customer && isDebtorPMV(customer, debtorUser?.details);
    const foundationFiles = documents
        ? getFoundations(documents).filter((d) => d.file)
        : [];
    // True when every registry the creditor can use requires a foundation, so we
    // force the foundation flag on (otherwise no registry would be selectable).
    const onlyFoundationRegistries = foundationCapableDescriptors.length > 0 &&
        foundationCapableDescriptors.every((d) => d.requiresFoundation);
    useEffect(() => {
        if (onlyFoundationRegistries) {
            setWithFoundation(true);
        }
    }, [onlyFoundationRegistries]);
    const availableRegistries = availableDescriptors.map((d) => ({
        registry: d.registry,
        label: d.label(lang),
        logo: d.logo,
    }));
    // Eligibility per registry the registration will be sent to, so a registry's
    // errors only show while it is selected (e.g. closed-registry errors like
    // MissingWarning never show for a Debitorregistret-only registration).
    // Picking "with foundation" is a request for an open registration, so every registry
    // is evaluated against the open path and reports the same open-path problems.
    // Memoized: the full eligibility scan is too heavy to re-run on every
    // keystroke in the amount field.
    const registryEvaluations = useMemo(() => kaseVouchers &&
        debtorUser &&
        interactions &&
        documents &&
        debtRegistries &&
        updates &&
        templates &&
        tenant
        ? availableDescriptors
            .filter((d) => selectedRegistries.size === 0 ||
            selectedRegistries.has(d.registry))
            .map(({ registry }) => ({
            registry,
            eligibility: canRegisterInRegistry(registry, singleCase, [debtorUser], kaseVouchers, debtRegistries, interactions, documents, updates, templates, { requireOpen: withFoundation }),
        }))
        : null, [
        kaseVouchers,
        debtorUser,
        interactions,
        documents,
        debtRegistries,
        updates,
        templates,
        tenant,
        availableDescriptors,
        selectedRegistries,
        singleCase,
        withFoundation,
    ]);
    const registrationErrors = registryEvaluations
        ? Array.from(new Set(registryEvaluations.flatMap((e) => e.eligibility.errors)))
        : null;
    return (React.createElement(Modal, { header: lang.debtRegistration.newRegistration, onToggle: props.toggleModal },
        React.createElement(Row, null,
            React.createElement(Col, { width: "6" },
                debtorUser &&
                    interactions &&
                    documents &&
                    updates &&
                    me &&
                    registrationErrors ? (React.createElement(React.Fragment, null,
                    registrationErrors.map((e) => (React.createElement(Alert, { key: e, size: "small", message: lang.debtRegistration.errors[e] }))),
                    React.createElement("br", null))) : null,
                availableRegistries.map(({ registry, label }) => (React.createElement(Checkbox, { key: registry, placeholder: label, checked: selectedRegistries.has(registry), onChange: (e) => {
                        const next = new Set(selectedRegistries);
                        e.target.checked ? next.add(registry) : next.delete(registry);
                        setSelectedRegistries(next);
                    } }))),
                React.createElement(SearchInput, { onSelect: (_userId) => {
                        setUserId(_userId);
                    }, static: debtorUser && debtorUser.details.name, onRemoveStatic: () => setUserId(null), placeholder: lang.debtRegistration.chooseDebtor, forceOpen: true, searchAll: searchDebtors }),
                debtorUser && isPMV && (React.createElement(Input, { placeholder: "Navn p\u00E5 person", value: getPersonName(debtorUser) || '', onChange: (e) => setPersonName(e.target.value) })),
                React.createElement(Input, { placeholder: lang.debtRegistration.amount, type: "number", value: amount || '', onChange: (e) => setAmount(e.target.value) }),
                !onlyFoundationRegistries && (React.createElement(Checkbox, { placeholder: lang.debtRegistration.withFoundation, checked: withFoundation, onChange: (e) => setWithFoundation(e.target.checked) })),
                withFoundation ? (React.createElement(React.Fragment, null,
                    !manglerAdvokatindestaaelse && (React.createElement(Select, { value: foundationCode, onChange: (e) => setFoundationCode(e.target.value) },
                        React.createElement("option", { value: "" },
                            "- ",
                            lang.debtRegistration.chooseFoundationType,
                            " -"),
                        Object.values(FoundationCode).map((e) => (React.createElement("option", { key: e, value: e }, lang.debtRegistration.foundationCode[e]))))),
                    React.createElement(DateInput, { placeholder: lang.debtRegistration.dateFoundation, onChange: (d) => setFoundationDate(d), value: foundationDate || undefined, maxDate: moment().toDate(), allowNull: true }),
                    manglerAdvokatindestaaelse &&
                        documents &&
                        (foundationFiles.length > 0 ? (React.createElement(FoundationFilePicker, null, foundationFiles.map((doc) => {
                            const file = doc.signedFile || doc.file;
                            const isChecked = selectedFiles.some((f) => f.fileId === file.fileId);
                            return (React.createElement(FoundationFileRow, { key: doc.documentId },
                                React.createElement(Checkbox, { checkMark: true, checkboxStyle: { margin: '0' }, style: { margin: '0' }, checked: isChecked, onChange: (e) => {
                                        setSelectedFiles(e.target.checked
                                            ? [...selectedFiles, file]
                                            : selectedFiles.filter((f) => f.fileId !== file.fileId));
                                    } }),
                                React.createElement(FileComponent, { file: file, style: { marginBottom: '0px', maxWidth: '50%' }, noWrap: true }),
                                React.createElement(Badge, { style: { marginBottom: '0px' }, theme: "lightgrey" }, lang.documentTypes[doc.type] || doc.type),
                                isDocumentFoundation(doc) && (React.createElement(Shield, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.documents.isFoundation, style: { color: '#3b92d3', flexShrink: 0 } })),
                                doc.signedAt && (React.createElement(CheckCircle, { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.documents.documentSigned, style: { color: '#3b92d3', flexShrink: 0 } }))));
                        }))) : (React.createElement(Alert, { size: "small", message: lang.debtRegistration.noFoundationsOnCase }))))) : (React.createElement(DateInput, { placeholder: lang.debtRegistration.latestWarningDate, onChange: (d) => {
                        setDateOfLatestWarning(d);
                    }, maxDate: moment().subtract(15, 'days').toDate(), value: dateOfLatestWarning || undefined, allowNull: true })),
                errorRequest ? (React.createElement(React.Fragment, null,
                    React.createElement("br", null),
                    React.createElement(Alert, { style: { backgroundColor: THEME.DANGEROUS }, key: errorDescription, size: "small", message: errorDescription }),
                    React.createElement(Table, { zebra: true, style: { fontSize: 'smaller' } }, Object.entries(errorRequest).map(([key, value]) => (React.createElement("tr", { key: key },
                        React.createElement("td", null, key),
                        React.createElement("td", null, value))))),
                    React.createElement("br", null))) : (React.createElement(React.Fragment, null,
                    React.createElement("br", null),
                    React.createElement(Table, { zebra: true },
                        React.createElement("tr", null,
                            React.createElement("td", null, "Kreditor"),
                            React.createElement("td", null,
                                React.createElement("b", null, creditor?.name))),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Debitortype"),
                            React.createElement("td", null, isPMV ? (React.createElement(React.Fragment, null,
                                React.createElement("b", null, "S"),
                                " (Personligt ejet mindre virksomhed)")) : customer?.isCompany ? (React.createElement(React.Fragment, null,
                                React.createElement("b", null, "F"),
                                " (Virksomhed)")) : (React.createElement(React.Fragment, null,
                                React.createElement("b", null, "P"),
                                " (Person)")))),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Referencenummer"),
                            React.createElement("td", null,
                                React.createElement("b", null,
                                    singleCase.id,
                                    "-",
                                    debtorUser?.id))),
                        customer?.isCompany && (React.createElement("tr", null,
                            React.createElement("td", null, "Virksomhedsnavn"),
                            React.createElement("td", null,
                                React.createElement("b", null, debtorUser?.details.name)))),
                        customer?.isCompany && (React.createElement("tr", null,
                            React.createElement("td", null, "CVR"),
                            React.createElement("td", null,
                                React.createElement("b", null, debtorUser?.details.cvr)))),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Adresse"),
                            React.createElement("td", null,
                                React.createElement("b", null, debtorUser?.details.address?.address))),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Postnr."),
                            React.createElement("td", null,
                                React.createElement("b", null, debtorUser?.details.address?.zipcode))),
                        React.createElement("tr", null,
                            React.createElement("td", null, "Beskyttet adresse"),
                            React.createElement("td", null,
                                React.createElement("b", null, debtorUser?.details.addressProtection ? 'Ja' : 'Nej')))),
                    React.createElement("br", null))),
                registrationResults &&
                    Object.values(registrationResults).some((r) => r?.status === 'error') && (React.createElement("div", { style: { marginBottom: '10px' } }, availableRegistries.map(({ registry, label, logo }) => {
                    const result = registrationResults[registry];
                    if (!result) {
                        return null;
                    }
                    return (React.createElement("div", { key: registry, style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            marginBottom: '4px',
                        } },
                        React.createElement("img", { src: logo, alt: label, style: { height: '16px' } }),
                        React.createElement(Badge, { theme: result.status === 'success'
                                ? THEME.SUCCESS
                                : THEME.DANGEROUS }, result.status === 'success'
                            ? 'OK'
                            : result.error || 'Fejl')));
                }))),
                React.createElement(Button, { block: true, disabled: !(selectedRegistries.size > 0 &&
                        Math.round((amount || 0) * 100) &&
                        props.userId &&
                        ((withFoundation &&
                            (foundationCode || manglerAdvokatindestaaelse) &&
                            foundationDate &&
                            (!manglerAdvokatindestaaelse || selectedFiles.length > 0)) ||
                            (!withFoundation && dateOfLatestWarning))), loading: reporting, onClick: registerReport }, lang.debtRegistration.infobox.registerButton)),
            React.createElement(Col, { width: "6" },
                React.createElement(Well, null,
                    React.createElement("div", { style: { display: 'flex', gap: '12px', marginBottom: '8px' } }, availableRegistries.map(({ registry, logo }) => (React.createElement("img", { key: registry, height: "50px", src: logo, style: {
                            opacity: selectedRegistries.has(registry) ? 1 : 0.3,
                        } })))),
                    debtorUser && (React.createElement("p", null,
                        collector && collector.name,
                        ' ',
                        lang.debtRegistration.infobox.herebyRegister,
                        ' ',
                        React.createElement("b", null, debtorUser.details.name),
                        ' ',
                        lang.debtRegistration.infobox.inThe,
                        ' ',
                        withFoundation
                            ? `${lang.debtRegistration.infobox.open}`
                            : `${lang.debtRegistration.infobox.closed}`,
                        ' ',
                        lang.debtRegistration.infobox.debtorNotPaid,
                        ' ',
                        React.createElement("b", null, formatNumber(Math.round((amount || 0) * 100))),
                        ".",
                        lang.debtRegistration.infobox.criteria)),
                    React.createElement("ul", null,
                        React.createElement("li", null, lang.debtRegistration.infobox.min18years),
                        React.createElement("li", null, lang.debtRegistration.infobox.min3messages),
                        withFoundation ? (React.createElement(React.Fragment, null,
                            React.createElement("li", null, lang.debtRegistration.infobox.totalDebt),
                            React.createElement("li", null, lang.debtRegistration.infobox.hasFoundation))) : (React.createElement(React.Fragment, null,
                            React.createElement("li", null, lang.debtRegistration.infobox.debtorWarning),
                            React.createElement("li", null, lang.debtRegistration.infobox.totalPrincipal),
                            React.createElement("li", null, lang.debtRegistration.infobox.noDemurral),
                            React.createElement("li", null, lang.debtRegistration.infobox.institutionsInfo)))),
                    React.createElement("p", { style: {
                            opacity: 0.7,
                            fontSize: '.7em',
                        } }, lang.debtRegistration.infobox.finePrint.NB),
                    React.createElement("p", { style: {
                            opacity: 0.7,
                            fontSize: '.7em',
                        } }, lang.debtRegistration.infobox.finePrint.letter),
                    React.createElement("p", { style: {
                            opacity: 0.7,
                            fontSize: '.7em',
                        } }, lang.debtRegistration.infobox.finePrint.expiration),
                    React.createElement("p", { style: {
                            opacity: 0.7,
                            fontSize: '.7em',
                        } }, lang.debtRegistration.infobox.finePrint.faultyData),
                    React.createElement("p", { style: {
                            opacity: 0.7,
                            fontSize: '.7em',
                        } }, lang.debtRegistration.infobox.finePrint.newClient))))));
};
export default NewRegistrationModal;
const FoundationFilePicker = styled.div `
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 8px;
`;
const FoundationFileRow = styled.div `
  display: flex;
  align-items: center;
  gap: 8px;
`;
//# sourceMappingURL=NewRegistrationModal.js.map